import { render } from "./ServiceCards.vue?vue&type=template&id=b049409a&scoped=true"
import script from "./ServiceCards.vue?vue&type=script&lang=js"
export * from "./ServiceCards.vue?vue&type=script&lang=js"

import "./ServiceCards.vue?vue&type=style&index=0&id=b049409a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b049409a"]])

export default __exports__